import {Button, Menu, MenuItem} from '@mui/material';
import {
  ComponentProps,
  JSXElementConstructor,
  ReactNode,
  useState,
} from 'react';

import {AMSEModuleNode} from '../../../interfaces/AMSEModuleNode';
import HistoryReportMenuItem from '../../common/HistoryReportMenuItem';

type ComponentType = keyof JSX.IntrinsicElements | JSXElementConstructor<any>;

interface Props<T extends ComponentType> {
  setViewType?: Function;
  onOpenItem?: Function;
  onOpenHistory?: Function;
  component?: T;
  componentProps?: ComponentProps<T>;
  children?: ReactNode;
  item?: AMSEModuleNode;
}

const AMSEModuleItemEditButton = <T extends ComponentType = typeof Button>({
  component,
  componentProps,
  children,
  onOpenItem,
  onOpenHistory,
  item,
}: Props<T>) => {
  const Component = component ?? Button;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const menuOpen = Boolean(anchorEl);

  return (
    <>
      <Component
        {...componentProps}
        onClick={(event) => setAnchorEl(event.currentTarget)}
      >
        {children}
      </Component>

      <Menu
        anchorEl={anchorEl}
        open={menuOpen}
        onBackdropClick={() => setAnchorEl(null)}
      >
        <MenuItem
          onClick={() => {
            onOpenItem?.(item?.id, 'e-module', 'update');
            setAnchorEl(null);
          }}
        >
          Edit eModule
        </MenuItem>
        <MenuItem
          onClick={() => {
            onOpenItem?.(item?.id, 'e-module', 'view');
            setAnchorEl(null);
          }}
        >
          Info & Actions
        </MenuItem>
        <HistoryReportMenuItem
          type="amsEmoduleCalibration"
          id={item?.id}
          onOpen={() => onOpenHistory?.(item?.id, 'amsEmoduleCalibration')}
          onAfterAction={() => setAnchorEl(null)}
        >
          View Calibration History
        </HistoryReportMenuItem>
        <HistoryReportMenuItem
          type="amsEmoduleInstallationHistory"
          id={item?.id}
          onOpen={() =>
            onOpenHistory?.(item?.id, 'amsEmoduleInstallationHistory')
          }
          onAfterAction={() => setAnchorEl(null)}
        >
          View Installstion History
        </HistoryReportMenuItem>
        <HistoryReportMenuItem
          type="amsEmoduleSensorHistory"
          id={item?.id}
          onOpen={() => onOpenHistory?.(item?.id, 'amsEmoduleSensorHistory')}
          onAfterAction={() => setAnchorEl(null)}
        >
          View Sensor History
        </HistoryReportMenuItem>
      </Menu>
    </>
  );
};

export default AMSEModuleItemEditButton;
